<template>
    <v-container
        fluid
        grid-list-lg
        fill-height
    >
        <v-layout row>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :loading="loading"
                    :items="users"
                    class="elevation-1"
                    :search="search"
                    sort-by="username"
                    hide-default-footer
                    :items-per-page="users.length + 1"
                >
                    <template v-slot:top>
                        <v-toolbar flat color="white" :hidden="!isAdmin">
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Suchen/Filtern"
                                single-line
                                clearable
                                hide-details
                            />
                            <v-spacer/>
                            <v-dialog
                                v-model="dialog"
                                max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        class="mb-2 text--secondary"
                                        v-on="on">
                                        Neuer Benutzer
                                    </v-btn>
                                </template>
                                <v-card
                                    :loading="dialogLoading"
                                    :disabled="dialogLoading">
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-text-field
                                                        :disabled="editedIndex > -1"
                                                        v-model="editedItem.username"
                                                        :rules="[rules.required, rules.counter]"
                                                        label="Benutzername">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.email"
                                                        :rules="[rules.email, rules.required]"
                                                        label="Email">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.firstName"
                                                        label="Vorname">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-text-field
                                                        v-model="editedItem.lastName"
                                                        label="Nachname">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" :hidden="!isAdmin">
                                                    <v-checkbox
                                                        v-model="editedItem.tenantAdmin"
                                                        label="Administratorrechte">
                                                    </v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" :hidden="!isSelf(editedItem.uuid)">
                                                    <v-text-field
                                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                        :type="show ? 'text' : 'password'"
                                                        v-model="editedItem.password"
                                                        @click:append="show = !show"
                                                        counter
                                                        label="Passwort">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer/>
                                        <v-btn
                                            class="text--secondary"
                                            text
                                            @click="close">
                                            Abbrechen
                                        </v-btn>
                                        <v-btn
                                            class="text--secondary"
                                            text
                                            :disabled="!savePossible"
                                            @click="save">
                                            Speichern
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.tenantAdmin="{ item }">
                        <v-icon v-if="item.tenantAdmin">mdi-check</v-icon>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-3"
                                    @click="editItem(item)"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>Ändern</span>
                        </v-tooltip>
                        <span :hidden="!isAdmin">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-3"
                                    :disabled="isSelf(item.uuid)"
                                    @click="deleteUser(item)"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>Löschen</span>
                        </v-tooltip>
                        </span>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    data: () => ({
        dialog: false,
        dialogLoading: false,
        loading: true,
        show: false,
        search: '',
        isAdmin: false,
        headers: [
            {text: 'Benutzername', value: 'username'},
            {text: 'Vorname', value: 'firstName'},
            {text: 'Nachname', value: 'lastName'},
            {text: 'Email-Adresse', value: 'email'},
            {text: 'Admin', value: 'tenantAdmin'},
            {text: '', value: 'action', sortable: false, align: 'end', filterable: false}
        ],
        rules: {
            required: value => !!value || 'Angabe wird benötigt.',
            counter: value => value.length >= 4 || 'Mindestens 4 Zeichen.',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Ungültige E-Mail.'
            }
        },
        users: [],
        editedIndex: -1,
        editedItem: {
            uuid: '',
            username: '',
            email: '',
            firstName: '',
            lastName: '',
            tenantAdmin: false,
            password: ''
        },
        defaultItem: {
            uuid: '',
            username: '',
            email: '',
            firstName: '',
            lastName: '',
            tenantAdmin: false,
            password: ''
        },
    }),
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Benutzer anlegen' : 'Benutzer ändern'
        },
        savePossible() {
            return this.editedItem.username.length > 3
                && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,7})+$/.test(this.editedItem.email)
        },
        usernameExist() {
            return this.users.find(u => u.username === this.editedItem.username) !== 'undefined';
        }
    },
    created() {
        this.loadUsers();
        this.checkIsAdmin()
    },
    methods: {
        isSelf(uuid) {
            return uuid === this.$keycloak.subject
        },
        checkIsAdmin() {
            axios.get('/user/api/user/' + this.$keycloak.subject + '/isAdmin/')
                .then(response => {
                    this.isAdmin = response.data.admin;
                })
        },
        loadUsers() {
            axios.get('/user/api/user/')
                .then(response => {
                    this.users = response.data;
                    this.loading = false
                })
        },
        editItem(item) {
            this.editedIndex = this.users.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true
        },
        deleteUser(item) {
            const index = this.users.indexOf(item);
            axios.delete('/user/api/user/' + item.uuid + '/')
                .then(() => {
                    this.users.splice(index, 1)
                })
        },
        close() {
            this.dialog = false;
            this.dialogLoading = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            }, 300)
        },
        save() {
            this.dialogLoading = true;
            if (this.editedIndex > -1) {
                axios.put('/user/api/user/' + this.editedItem.uuid + '/', this.editedItem)
                    .then(() => {
                        this.loadUsers();
                        this.close()
                    })
            } else {
                axios.post('/user/api/user/', this.editedItem)
                    .then(() => {
                        this.loadUsers();
                        this.close()
                    })
            }
        }
    }
}
</script>
